export default __webpack_public_path__ + "static/marketIntegrationMobile3-7cc3dac5c2827114f18c608b2b4a3e01.jpg";